/** Stable IDs for physical storage and transportation types shared across applications. */

// Shared verbatim with the HazWaste branch, minus its `FacilityStorageLocationBrief` and
// `FacilityStorageVesselBrief` aliases — those name HazWaste-only tables that this branch has no
// migrations for. The ID list below must stay identical to HazWaste's so the two merge as one file.

export const storageTypeIDs = [
  'biohazard-bag-red',
  'biohazard-bag-yellow',
  'universal-waste-lamp-container',
  'sharps-container',
  'glass-carboy',
  'custom-container',
  'bag',
  'super-sack-bulk-bag',
  'fiber-plastic-box',
  'wooden-box',
  'metal-box',
  'gaylord-box',
  'battery-box-pallet',
  'metal-drum',
  'fiber-plastic-drum',
  'wooden-drum',
  'overpack-drum',
  'lab-pack-drum',
  'pail',
  'cylinder',
  'ibc-tote',
  'portable-tank',
  'vertical-aboveground-tank',
  'horizontal-aboveground-tank',
  'double-wall-tank',
  'mobile-frac-tank',
  'roll-off-container',
  'front-load-dumpster',
  'rear-load-dumpster',
  'compactor-container',
  'vacuum-box-sludge-box',
  'hopper',
  'dump-truck',
  'cargo-tank-truck',
  'tank-car',
  'hopper-gondola-rail-car',
  'small-parts-washer',
  'other',
] as const;

export type StorageTypeID = (typeof storageTypeIDs)[number];

export const rcraStationaryTankStorageTypeIDs = [
  'vertical-aboveground-tank',
  'horizontal-aboveground-tank',
  'double-wall-tank',
] as const satisfies readonly StorageTypeID[];

export function isRcraStationaryTankStorageTypeID(
  storageTypeID: string | null | undefined,
): storageTypeID is (typeof rcraStationaryTankStorageTypeIDs)[number] {
  return rcraStationaryTankStorageTypeIDs.includes(storageTypeID as (typeof rcraStationaryTankStorageTypeIDs)[number]);
}
